<div class="spinner-container" [class.pill]="!iconOnly" role="status" [attr.aria-label]="text | translate">
    <span class="ring" [style.width.px]="diameter" [style.height.px]="diameter" [style.--ring-color]="ringColor"
        [style.--ring-stroke.px]="stroke"></span>

    <span *ngIf="!iconOnly" class="spinner-text" [style.fontSize.px]="fontSize" [style.minWidth]="textWidth"
        [style.textAlign]="textWidth ? 'center' : ''">
        {{ text | translate }}
    </span>
</div>